module.exports = __webpack_public_path__ + "img/da8ca4c8e109d3442ebb77baa4ed80ec.d7b2010d.png";